// Exports the "tabfocus" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/tabfocus')
//   ES2015:
//     import 'tinymce/plugins/tabfocus'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/tabfocus/index.js
// module id = 631
// module chunks = 0